import { useMutation } from "react-query";
import Api, { IApi } from "../../services/Api";
import { Fichier } from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";
import { buildBlob } from "../../helpers/utils";

export const useGetDocument = () => {
  const api: IApi = Api.create(getApiEndpoint());

  return useMutation<Fichier, any, number>(
    // @ts-ignore
    (params: number) => (api && api.getDocument(params)) || undefined,
    {
      onSuccess: (data: Fichier) => {
        data &&
          data.content &&
          buildBlob(data.content, data.typeMime, data.nom);
      },
    }
  );
};

export const useDeleteDocument = () => {
  const api: IApi = Api.create(getApiEndpoint());

  return useMutation<number, any, number>(
    // @ts-ignore
    (params: number) => (api && api.deleteDocument(params)) || undefined
  );
};
